__webpack_require__.p = "https://assets-dev.nextorder.co/build-assets/dev-build-2025-12-29-1767013967-stable-dev/";